export default "__VITE_ASSET__By5Wp8uW__"